import { Detector } from "react-detect-offline";
import Login from "@fadmin/components/Login";
import { LFlex, LHero, LSubTitle } from "@components";

export const RootPage = (): JSX.Element => {
    return (
        <>
            <Detector
                render={({ online }) => {
                    return online ? (
                        <Login />
                    ) : (
                        <LHero centered contentCentered isFullheight>
                            <LFlex alignCenter justifyCenter>
                                <LSubTitle size="1" color="has-text-dark-blue">
                                    {"You are offline. Please wait for the network connection to come back."}
                                </LSubTitle>
                            </LFlex>
                        </LHero>
                    );
                }}
            ></Detector>
        </>
    );
};
